export default function getMarginTopLg(value) {
  switch (value) {
    case -44:
      return "lg:-mt-44";
    case -40:
      return "lg:-mt-40";
    case -36:
      return "lg:-mt-36";
    case -32:
      return "lg:-mt-32";
    case -28:
      return "lg:-mt-28";
    case -24:
      return "lg:-mt-24";
    case -20:
      return "lg:-mt-20";
    case -16:
      return "lg:-mt-16";
    case -12:
      return "lg:-mt-12";
    case -8:
      return "lg:-mt-8";
    case -4:
      return "lg:-mt-4";
    case 0:
      return "lg:mt-0";
    case 1:
      return "lg:mt-1";
    case 2:
      return "lg:mt-2";
    case 3:
      return "lg:mt-3";
    case 4:
      return "lg:mt-4";
    case 5:
      return "lg:mt-5";
    case 6:
      return "lg:mt-6";
    case 7:
      return "lg:mt-7";
    case 8:
      return "lg:mt-8";
    case 9:
      return "lg:mt-9";
    case 10:
      return "lg:mt-10";
    case 12:
      return "lg:mt-12";
    case 14:
      return "lg:mt-14";
    case 16:
      return "lg:mt-16";
    case 20:
      return "lg:mt-20";
    case 24:
      return "lg:mt-24";
    case 28:
      return "lg:mt-28";
    case 32:
      return "lg:mt-32";
    case 36:
      return "lg:mt-36";
    case 40:
      return "lg:mt-40";
    default:
      return "";
  }
}
